import { api } from '@/core/lib/api-client';

export interface OnboardingProgress {
  id: string;
  hotelId: string;
  currentStep: number;
  totalSteps: number;
  completedSteps: string[];
  status: 'in-progress' | 'completed' | 'abandoned';
  stepsData: Record<string, Record<string, unknown>>;
  startedAt: string;
  completedAt: string | null;
}

export interface OnboardingProgressResponse {
  data: OnboardingProgress;
}

export interface SaveStepDto {
  stepId: string;
  data: Record<string, unknown>;
}

export interface SaveStepResponse {
  data: OnboardingProgress;
  message: string;
}

export interface CompleteOnboardingResponse {
  data: OnboardingProgress;
  message: string;
}

export class OnboardingService {
  private static BASE = '/hotel/onboarding';

  static async getProgress(): Promise<OnboardingProgressResponse> {
    return api.get<OnboardingProgressResponse>(`${this.BASE}/progress`);
  }

  static async saveStep(dto: SaveStepDto): Promise<SaveStepResponse> {
    return api.post<SaveStepResponse>(`${this.BASE}/steps`, dto);
  }

  static async complete(): Promise<CompleteOnboardingResponse> {
    return api.post<CompleteOnboardingResponse>(`${this.BASE}/complete`);
  }
}
